import { useTranslation } from 'react-i18next'
import { ClassNameProps } from 'types/utilities'
import SimpleSelect, { Option } from 'components/generic/Select'
import styles from './styles/dropdownAgeGroups.module.scss'
import cx from 'classnames'
import { AGE_GROUPS } from 'constants/player-search'

interface Props extends ClassNameProps {
  value: string
  setValue: (value: string) => void
}

const DropdownAgeGroups = ({ className, value, setValue }: Props) => {
  const { t: tFilterBar } = useTranslation('strFilterBar')

  const makeTriggerLabel = (option: Option) => {
    const selectedAgeGroup = AGE_GROUPS.find(g => g.value === option.value)
    if (!selectedAgeGroup) return tFilterBar('anyAgeGroup')

    return isNaN(Number(selectedAgeGroup.value))
      ? tFilterBar('ageGroupCompositeDropdownLabel', { ageGroup: selectedAgeGroup.label })
      : selectedAgeGroup.label
  }

  return (
    <SimpleSelect
      value={value}
      onValueChange={setValue}
      placeholder={tFilterBar('anyAgeGroup')}
      makeTriggerLabel={makeTriggerLabel}
      options={AGE_GROUPS}
      classNames={{ main: cx(styles.ageGroupFilter, { '--is-active': !!value }) }}
      size='small'
      withClearOption
    />
  )
}

export default DropdownAgeGroups
